import Update from "../../table/Update";
import { useEffect, useState } from "react";
import ApiService from "../../../services/apiService";
import { updateKml, kmlTitle } from "../../../constants";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify"
import { Row, Modal, ModalBody, ModalFooter, ModalHeader, Container, Button, Col } from "reactstrap";
import { useRef } from "react";
const UpdateKml = () => {
    const { id } = useParams();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [checkboxValue, setCheckboxValue] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsDeleteModalOpen(true)
    }, [])

    const handleButtonClick = () => {

        setIsDeleteModalOpen(false)

        setCheckboxValue(prev => !prev)
        toast.success("kml updated")

    };


    const handleUpdateKml = async (event: any) => {
        const File = event.target.files?.[0];
        if (!File) return
       
        const formData = new FormData();
        formData.append("file", File);
        formData.append("PlotOnMap", String(checkboxValue));
        try {
            console.log(id)
            const response = await ApiService.axiosApi(`/kml/${id}`, {
                method: 'PUT',
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            if (response.success) {
                toast.success("Kml Updating...")

            } else {
                toast.error("Unable To Update Kml")
                console.log(response.message)

            }
        } catch (error: any) {
            console.log(error)
        }
    }

    return (

        <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>

            <ModalHeader>Upload Kml</ModalHeader>
            <ModalBody>
                <Col>
                    <Row className="align-items-center">
                        <Col xs="auto">
                            <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
                                <input
                                    type="checkbox"
                                    name="plotOnMap"
                                    checked={checkboxValue}
                                    onChange={(e) => setCheckboxValue(e.target.checked)}
                                />
                                Plot on Map
                            </label>
                        </Col>

                        <Col xs="auto">
                            <input
                                type="file"
                                accept=".kml"
                                id="profilePicUpload"
                                ref={fileInputRef}
                                onChange={handleUpdateKml}
                            />
                        </Col>
                    </Row>
                </Col>

            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={() => { handleButtonClick(); navigate(-1) }}>Upload</Button>
                <Button color="secondary" onClick={() => { setIsDeleteModalOpen(false); navigate(-1) }}>Cancel</Button>
            </ModalFooter>

        </Modal>


    )
}
export default UpdateKml;



